import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { t } from 'i18next';
import InlineTable, { InlineColDef } from '../util/InlineTable';

interface Cat { id: number; name: string; active: boolean | null; }

const columns: InlineColDef<Cat>[] = [
  { key: 'name', label: t('Name') || 'Name', type: 'text', placeholder: t('Name') || 'Name…' },
];

const CategoryEqu: React.FC = () => {
  const [rows, setRows] = useState<Cat[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try { const { data } = await axios.get('category-equipment'); setRows(Array.isArray(data) ? data : []); }
    catch {} finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleAdd = async (row: Partial<Cat>) => {
    if (!row.name?.trim()) return;
    await axios.post('category-equipment/add', { name: row.name.trim() });
    await load();
  };

  const handleEdit = async (id: string | number, row: Partial<Cat>) => {
    await axios.put(`category-equipment/${id}`, { name: row.name });
    await load();
  };

  const handleDelete = async (id: string | number) => {
    if (!window.confirm(t('AreYouSure') || 'Are you sure?')) return;
    await axios.delete(`category-equipment/${id}`);
    await load();
  };

  return (
    <div className="bg-[var(--bg-form)] rounded-[5px]" style={{ border: 'var(--border-input)', overflow: 'hidden' }}>
      <InlineTable<Cat>
        columns={columns}
        rows={rows}
        getKey={r => r.id}
        loading={loading}
        onAdd={handleAdd}
        onEdit={handleEdit}
        onDelete={handleDelete}
        addLabel={`+ ${t('CatEqu') || 'Category'}`}
        emptyText={t('Empty') || 'No categories'}
      />
    </div>
  );
};

export default CategoryEqu;
